import { Dispatch } from 'react';
import * as XLSX from 'xlsx';

export const getFile = async <T = any>(event: any, dispatch: React.Dispatch<React.SetStateAction<T[]>>, setFile?: Dispatch<any>) => {
    const file = await event?.target?.files[0].arrayBuffer();
    const workbook = XLSX.read(file, { type: 'buffer' });
    const raw_data = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[raw_data];
    const req = await event
    dispatch(XLSX.utils.sheet_to_json<T>(worksheet));
    setFile?.(req);
}
